import { Optional, Inject, Injectable } from '@angular/core';
import { HttpClient} from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class SymbolService {
  private appSettings: any;
  modNewsUrl : any;
 
  constructor(private http: HttpClient,
    @Optional() @Inject('AppSettings') appSettings: any
    ) {
      this.modNewsUrl = appSettings.ibdConfigMap.modApiUrl;
    }

  navigateSymbol(symbol: any) {
    let quoteUrl = "";
    let quoteParam = {};
    this.getData(symbol, this.modNewsUrl).subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          let modSymbolResponse;
          let found = false;
          for (let k = 0; k < data.length; k++) {
            if (data[k].Symbol === symbol) {
              found = true;
              modSymbolResponse = data[k];
              break;
            }
          }
          quoteParam = { Symbol: symbol };
          quoteUrl = this.getQuoteUrl(found, modSymbolResponse);

          this.goto(quoteParam, quoteUrl);
        } else {
          //console.log("NO DATA FOUND IN SYMBOL LOOKUP");
          this.goto(quoteParam, "/nxi/research/quotenews/overviewnews");
        }
      },
      (err) => {
        console.log(err);
        this.goto(quoteParam, "/nxi/research/quotenews/overviewnews");
      }
    );
  }

  public getQuoteUrl(found: boolean, modSymbolResponse: any): string {
    let quoteUrl = "";
    if (found === true && typeof modSymbolResponse !== "undefined" && typeof modSymbolResponse["NormalIssueType"] !== "undefined") {
      switch (modSymbolResponse["NormalIssueType"]) {
        case 'S':
          quoteUrl = "/nxi/research/quotenews/stocks/summary";
          break;
        case 'ETF':
          quoteUrl = "/nxi/research/quotenews/etf/etfsummary";
          break;
        case 'MF':
          quoteUrl = "/nxi/research/quotenews/mutualfunds/mfsummary";
          break;
        case 'INX':
          quoteUrl = "/nxi/research/quotenews/overviewnews";
          break;
        default:
          quoteUrl = "/nxi/research/quotenews/overviewnews";
      }

    } else {
      quoteUrl = "/nxi/research/quotenews/overviewnews";
    }
    return quoteUrl;

  }

  public getData(symbol: any,modurl: any): any {
    let urlStart = modurl+'/public/lookup';
    let params = [];
    params.push("symbol=" + symbol + "&normalizeAssetType=true");
    let url = urlStart + "?" + params.join("&");
    return this.http.jsonp(url, "callback");
  }

 public goto(quoteParam: any, quoteUrl: string) {
    document.dispatchEvent(
      new CustomEvent("portal.gotoview", {
        detail: {
          gotoParams: quoteParam,
          gotoPage: quoteUrl,
        },
      })
    );
  }
}
